import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./Header";

export default function ResourceViewer() {
  const { url } = useParams();
  const decodedUrl = url ? decodeURIComponent(url) : "";

  useEffect(() => {
    const urlName = decodedUrl ? new URL(decodedUrl).hostname.replace('www.', '') : 'Resource';
    document.title = `TOC > Resources > ${urlName}`;
  }, [decodedUrl]);


  return (
    <div className="w-full max-w-full sm:max-w-[500px] min-h-screen md:min-h-[550px] flex-col bg-pink-50 flex items-center mx-auto">
      <Header />

      {/* Content with iframe */}
      <div className="w-full flex-1 flex flex-col bg-white">
        <div className="p-2 bg-gray-100 border-b border-gray-300 flex items-center justify-between">
          <Link
            to="/resources"
            className="text-sm text-[#f7adc4] hover:text-[#f49fb8] font-semibold flex items-center gap-2"
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4A1 1 0 018.707 6.293L6.414 8.586H17a1 1 0 110 2H6.414l2.293 2.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
            Back to Resources
          </Link>
          <a
            href={decodedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-gray-600 hover:text-[#f7adc4]"
          >
            Open in new tab
          </a>
        </div>
        <iframe
          src={decodedUrl}
          className="w-full flex-1 border-0"
          title="Resource Content"
          style={{ minHeight: "500px" }}
        />
      </div>

      {/* Footer */}
      <div className="w-full bg-[#f7adc4] text-white text-center flex justify-center items-center px-4 py-2 mt-auto">
        <img src="/1.png" alt="Logo" className="h-auto w-16 sm:w-20" />
      </div>
    </div>
  );
}
